var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.58317V12.1665C18.3334 14.0333 18.3334 14.9668 17.9701 15.6798C17.6505 16.307 17.1406 16.8169 16.5134 17.1365C15.8003 17.4998 14.8669 17.4998 13.0001 17.4998H7.00008C5.13324 17.4998 4.19982 17.4998 3.48678 17.1365C2.85957 16.8169 2.34964 16.307 2.03006 15.6798C1.66675 14.9668 1.66675 14.0333 1.66675 12.1665V7.83317C1.66675 5.96633 1.66675 5.03291 2.03006 4.31987C2.34964 3.69266 2.85957 3.18273 3.48678 2.86315C4.19982 2.49984 5.13324 2.49984 7.00008 2.49984H10.4167M15.8334 6.6665V1.6665M13.3334 4.1665H18.3334M13.3334 9.99984C13.3334 11.8408 11.841 13.3332 10.0001 13.3332C8.15913 13.3332 6.66675 11.8408 6.66675 9.99984C6.66675 8.15889 8.15913 6.6665 10.0001 6.6665C11.841 6.6665 13.3334 8.15889 13.3334 9.99984Z",
    stroke: "#631517",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamers);
export default __webpack_public_path__ + "static/media/camers.ed519a1dc6589ac7920771d28ae8959f.svg";
export { ForwardRef as ReactComponent };